<template>
  <div>
    <v-form ref="form" lazy-validations class="text-center">
      <div class="forms-form-box">
        <div class="container">
          <small>ارسال گزارش برای :</small>
          <h2>{{name}}</h2>
          <v-divider class="my-5"></v-divider>
          <v-row class="text-center">
            <template v-for="f in form">
              <v-col cols="12"
                     v-if="f.name==='توضیحات'"
              >
                <v-text-field
                    outlined
                    :rules="form_inputs_rule"
                    v-model="f.value"
                    :label="f.name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" lg="6" xl="4" xxl="3"
                     v-else
              >
                <v-text-field

                    :rules="form_inputs_rule"
                    v-model="f.value"
                    outlined
                    :label="f.name"
                ></v-text-field>
              </v-col>
            </template>
          </v-row>
        </div>
        <div class="w-100 text-center ma-10">
          <div class="mx-auto my-5" style="max-width: 20em;">
            <v-btn @click="submit"
                   color="success"
                   block large
                   :loading="submit_btn.sending"
            >
              ثبت فرم
            </v-btn>
          </div>
        </div>
      </div>
    </v-form>
  </div>
</template>

<script>

export default {
  name: "monthlyCheck",
  props:['submit_btn', 'name'],
  data:()=>({
    form_inputs_rule: [value => !!value || 'اجباری'],
    form:[
      {value:'', name: "تابلو برق",},
      {value:'', name: "پمپ ها",},
      {value:'', name: "الکترو موتور ها",},
      {value:'', name: "دیگ ها",},
      {value:'', name: "مشعل ها",},


      {value:'', name: "منابع کوئیلی/مبدل",},
      {value:'', name: "منابع انبساط",},
      {value:'', name: "لوله ها",},
      {value:'', name: "شیرآلات",},
      {value:'', name: "کلکتور ها",},


      {value:'', name: "آکوستات ها",},
      {value:'', name: "شیر های اطمینان فشار",},
      {value:'', name: "سختیگیر ها",},
      {value:'', name: "توضیحات",},

    ],
  }),
  methods: {
    submit(){
      if (this.validate()) this.$emit('submit', this.form);
    },
    validate () {
      return this.$refs.form.validate()
    },
  }
}
</script>
